import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { IConsentFormResult } from "src/interfaces/interfaces";
import {
  ConsentService,
  FULL_CONSENT,
  MINIMAL_CONSENT,
} from "src/services/consent-service";
import { ThemeService } from "src/services/theme.service";
import { ModalComponent } from "../modal/modal.component";
import { CheckboxComponent } from "../../inputs/checkbox/checkbox.component";
import { RouterLink } from "@angular/router";
import { ButtonBareComponent } from "../../inputs/button/button-bare.component";
import { TranslateModule } from "@ngx-translate/core";

type ConsentForm = {
  [key in keyof IConsentFormResult]: FormControl<IConsentFormResult[key]>;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-cookie-consent",
  templateUrl: "./cookie-consent.component.html",
  imports: [
    ModalComponent,
    CheckboxComponent,
    RouterLink,
    ButtonBareComponent,
    TranslateModule,
  ],
})
export class CookieConsentComponent implements OnInit, OnDestroy {
  hasConsent = false;
  showAdjust = false;
  cookiesForm = new FormGroup<ConsentForm>({
    required: new FormControl(
      { value: true, disabled: true },
      { nonNullable: true },
    ),
    functional: new FormControl(true, { nonNullable: true }),
    performance: new FormControl(true, { nonNullable: true }),
    marketing: new FormControl(true, { nonNullable: true }),
  });
  isOpen = false;

  private subscription: Subscription;

  constructor(
    private consentService: ConsentService,
    protected themeService: ThemeService,
  ) {
    this.subscription = this.consentService.dialog.subscribe((ev) => {
      if (ev === "open") {
        this.open();
      }
      if (ev === "close") {
        this.close();
      }
    });
  }

  open() {
    if (this.isOpen) return;
    const { controls } = this.cookiesForm;
    this.cookiesForm.setValue({
      required: true,
      functional:
        this.consentService.functionalConsent.value ??
        controls.functional.defaultValue,
      marketing:
        this.consentService.marketingConsent.value ??
        controls.marketing.defaultValue,
      performance:
        this.consentService.performanceConsent.value ??
        controls.performance.defaultValue,
    });
    this.isOpen = true;
  }

  close() {
    this.showAdjust = false;
    this.isOpen = false;
  }

  ngOnInit(): void {
    if (this.consentService.requiredConsent.value !== true) {
      this.open();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  goToAdjust(): void {
    this.showAdjust = true;
  }

  consentForm(): void {
    this.consentService.consentFromForm(this.cookiesForm.getRawValue());
    this.close();
  }

  consentAll(): void {
    this.consentService.consentFromForm(FULL_CONSENT);
    this.close();
  }

  consentMinimal(): void {
    this.consentService.consentFromForm(MINIMAL_CONSENT);
    this.close();
  }
}
